export default __webpack_public_path__ + "static/media/factionlessart2_hd.b144497f.webp";